import * as React from 'react';

function useAsyncState(initialState, fn, dependencyList) {
    const [result1, setResult] = React.useState(initialState);
    const [error1, setError] = React.useState();
    React.useEffect(()=>{
        let isMounted = true;
        fn().then((result)=>{
            if (!isMounted) return;
            setResult(result);
        }).catch((error)=>{
            if (!isMounted) return;
            setError(error);
        });
        return ()=>{
            isMounted = false;
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencyList);
    return {
        result: result1,
        error: error1
    };
}

export { useAsyncState };
//# sourceMappingURL=use-async-state.js.map
